var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavProductionIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.968,
    height: 15.968,
    viewBox: "0 0 15.968 15.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_nav_product_icon",
    transform: "translate(-32.432 -650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mobile_nav_product_icon-2",
    "data-name": "mobile_nav_product_icon",
    d: "M3.33,0H5.138l6.153,6.153V7.961ZM7.961,0l3.33,3.33V5.138L6.153,0ZM9.88,0a1.36,1.36,0,0,1,1,.413,1.36,1.36,0,0,1,.413,1v.9L8.976,0Zm0,11.291h-.9L0,2.316v-.9A1.349,1.349,0,0,1,.2.706L10.585,11.093a1.349,1.349,0,0,1-.706.2Zm-3.727,0L0,5.138V3.33l7.961,7.961H6.153Zm-2.823,0L0,7.961V6.153l5.138,5.138H3.33Zm-1.919,0a1.36,1.36,0,0,1-1-.413A1.36,1.36,0,0,1,0,9.88v-.9l2.316,2.316h-.9ZM1.411,0h.9l8.976,8.976v.9a1.349,1.349,0,0,1-.2.706L.706.2A1.349,1.349,0,0,1,1.411,0Z",
    transform: "translate(32.432 657.984) rotate(-45)",
    fill: "#7c4dff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProductionIcon1);
export default __webpack_public_path__ + "static/media/navProductionIcon1.7e972daeccd75d8034295b6e97df5b07.svg";
export { ForwardRef as ReactComponent };